import { FC } from 'react';
import { Modal } from 'antd';
import AddProductType from './addProductType';
import ProductTypeList from './ProductTypeList';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadProductTypes } from './ProductTypeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { AppState } from '../../redux/store/rootReducer';
import { loadBodySizes } from '../bodySize/bodySizeSlice';
import { loadOrificeSizes } from '../orificeSize/orificeSizeSlice';
import { loadCategory } from '../category/categorySlice';
const ProductType: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, setEditBodySize, editBodySize } = React.useContext(CommonContext) as CommonContextType;
  /*   const ProductTypes = useSelector(
      (state: AppState) => state.ProductTypes
    ); */
  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditBodySize(null)
    setModelChange(false);
  };

  React.useEffect(() => {
    dispatch(loadProductTypes());
    dispatch(loadCategory());
    dispatch(loadBodySizes());
    dispatch(loadOrificeSizes());
  }, [dispatch]);

  return (
    <div className='padding' style={{ background: '#ffffff' }}>
      {contextHolder}
      <br></br>
      <h2>Product Type List
        <button className='top-button' onClick={showModal}>Create</button>
      </h2>
      <br></br>
      <ProductTypeList />
      <Modal title={editBodySize?.id ? 'Edit Product Type' : 'Create Product Type'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddProductType />
      </Modal>
    </div>
  );

};

export default ProductType;